import { T as TraySpeakerHolder, d as defineCustomElement$1 } from './tray-speaker-holder.js';

const TtTraySpeakerHolder = TraySpeakerHolder;
const defineCustomElement = defineCustomElement$1;

export { TtTraySpeakerHolder, defineCustomElement };
